import { useMutation } from "@tanstack/react-query";
import { feedbackApiService } from "../services/feedbackApiService";
import {
  fromSendFeedbackRequestToSendFeedbackDto,
  type FeedbackReceiptDto,
  type SendFeedbackRequest,
} from "../types/feedbackTypes";

export const useSendFeedback = () => useMutation<FeedbackReceiptDto, Error, SendFeedbackRequest>({
  meta: { action: "feedback.send" },
  mutationFn: (request) => feedbackApiService.send(fromSendFeedbackRequestToSendFeedbackDto(request)),
});
